import req from '../lib/req';
import { Bureau, Id } from '@/types';
import { BureauFlags, BureauListRow } from '@/types/Bureau';

export async function findById(id: Id): Promise<Bureau> {
  return await req.get(`/bureau/${id}`).then((response) => response.data);
}

/**
 * Finds all bureaus, including the inactive ones. Only for Koda admins.
 */
export async function findAll(): Promise<BureauListRow[]> {
  return req.get('/v2/bureaus/all').then((response) => response.data);
}

/**
 * Sets the given flags of the bureau, flags left out are not changed.
 * Only for Koda admins.
 */
export async function setFlags(
  id: Id,
  flags: BureauFlags
): Promise<BureauListRow> {
  return req
    .put(`/v2/bureaus/${id}/flags`, flags)
    .then((response) => response.data);
}
